module.exports = __webpack_public_path__ + "fd09297c94c399670671515d0471428d.png";